import React, { useEffect, useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col,
    Container,
} from 'reactstrap';
  
import { toast } from 'react-toastify';

const PhysiotherapyModalCancel = ({
    requestId,
    submitModal,
    closeModal,
    onComplete,
    modalIsOpen,
    className
}) => {

    const [value, setValue] = useState('');
    const [remarks, setRemarks] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        // Reset state when modal opens or requestId changes
        if (modalIsOpen) {
            setValue('');
            setRemarks('');
        }
    }, [requestId, modalIsOpen]);

    const handleChange = (event) => {
        const { value } = event.target;
        setValue(value);
        setRemarks('');
    };

    const handleRemarksInputChange = (event) => {
        setRemarks(event.target.value);
    };

    const handleSubmit = () => {
        if(!value || !remarks) {
            return toast.error('No value/remark selected');
        }

        setIsDisabled(true); // Disable the button

        return submitModal(value, remarks)
        .then(() => {
            closeModal();
            onComplete();
        })
        .finally(() => {
            setIsDisabled(false); // Re-enable the button after the process is complete
        });
    };

    const getRemarksSelectOptions = () => {
        switch (value) {
            case "Doctor Unavailable": {
                return [ "",  "Profiling Error", "Doctor On Leave", "All slots booked", "Doctor went for emergency/IPD", "Corona", "Doctor Unavailable at requested location" ];
            }
            case "Doctor Couldn’t get onboarded": {
                return [ "", "doctor didn’t respond to our calls", "Denied 3rd party payment" ];
            }
            default:
                return [];
        }
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            toggle={closeModal}
            className={className}
        >
            <ModalHeader className="bg-primary" toggle={closeModal}>
                Sure you want to cancel? (Request Id: {requestId})
            </ModalHeader>
            <ModalBody>
                <Container>
                    <Row>
                        <Col>
                            <Row>
                                <label>Reason for cancellation:</label>
                            </Row>
                            <br />
                            <Row>
                                <div>
                                    <select onChange={handleChange} value={value}>
                                        <option value="">Select Reason</option>
                                        <option value="Physiotherapist unavailable">Physiotherapist unavailable</option>
                                        <option value="Centre closed due to emergency">Centre closed due to emergency</option>
                                        <option value="Slot no longer available">Slot no longer available</option>
                                        <option value="Equipment/facility issue">Equipment/facility issue</option>
                                        <option value="Patient not available">Patient not available</option>
                                        <option value="Not covered under policy">Not covered under policy</option>
                                        <option value="Visit Demo">Visit Demo</option>
                                    </select>
                                </div>
                            </Row>
                            <br />
                            <Row>
                                <div>
                                    <React.Fragment>
                                        {getRemarksSelectOptions().length ? (
                                            <select value={remarks} onChange={handleRemarksInputChange}>
                                                {getRemarksSelectOptions().map((option) => (<option key={option} value={option}>{option || "Select Remark"}</option>))}
                                            </select>
                                        ) : (
                                            <input onChange={handleRemarksInputChange} value={remarks} />
                                        )}
                                    </React.Fragment>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </ModalBody>
            <ModalFooter>
                <Button color="info" onClick={handleSubmit} disabled={isDisabled}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PhysiotherapyModalCancel;
